import { render, staticRenderFns } from "./delete-confirmation-modal.vue?vue&type=template&id=6e2b64a6"
import script from "./delete-confirmation-modal.vue?vue&type=script&lang=js"
export * from "./delete-confirmation-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports